import platformConfig from '~/platform.branding.json';
// import Config from '@/Config.js';
const currentPlatformConfig = platformConfig['Ideafound'] || {};

const stripeConfig = {
    appearance: {
        theme: 'flat',
        rules: {
            '.AccordionItem': {
                border: '2px solid #D0CED1',
            },
        },
        variables: {
            colorPrimary: '#373438',
            colorText: '#373438',
            iconColor: '#5F5A61',
            colorDanger: '#D33257',
            fontFamily: `${currentPlatformConfig?.FontFamily.Base}, system-ui, sans-serif`,
            borderRadius: '4px',
        },
    },
    layout: {
        type: 'accordion',
        defaultCollapsed: false,
        radios: true,
        spacedAccordionItems: false,
    },
    validationPlaceholders: {
        email: 'stripe_placeholder@example.com',
        holderName: 'stripe_placeholder',
        encryptedCardNumber: 'stripe_placeholder',
        encryptedExpiryMonth: 'stripe_placeholder',
        encryptedExpiryYear: 'stripe_placeholder',
        encryptedSecurityCode: 'stripe_placeholder',
    },
};

export default stripeConfig;